import { getTenant } from 'services/tenants';

const allowedProjects = new Set([
  'themis',
  'staging',
  'development',
  'preview'
]);

export const shouldApplyImageRestrictions = () => {
  const tenant = getTenant();
  return allowedProjects.has(tenant.project);
};
